import axios from "axios";
import { apiConfig, authenticatedApiConfig } from "./BaseApiService";
export class AnalyticsService {
    constructor(authManager, environment) {
        this.authManager = authManager;
        this.environment = environment;
    }
    async trackEvent(event) {
        try {
            const orgId = this.authManager.anyOrgId;
            if (!orgId) {
                console.warn("Analytics skipped: Organization ID is missing");
                return;
            }
            await axios.post(`${this.environment.API_BASE_URL}/organizations/${orgId}/event`, event, authenticatedApiConfig(this.authManager));
        }
        catch (error) {
            console.error("Failed to track analytics event:", error);
        }
    }
    async trackPublicEvent(event) {
        try {
            await axios.post(`${this.environment.API_BASE_URL}/analytics/event`, event, apiConfig());
        }
        catch (error) {
            console.error("Failed to track public analytics event:", error);
        }
    }
    async trackHeapEvent(event) {
        try {
            await axios.post(`${this.environment.API_BASE_URL}/analytics/heapEvent`, event, apiConfig());
        }
        catch (error) {
            console.error("Failed to track heap analytics event:", error);
        }
    }
    async identifyUser(identity, userId) {
        try {
            await axios.post(`${this.environment.API_BASE_URL}/analytics/identifyUser`, { identity, userId }, apiConfig());
        }
        catch (error) {
            console.error("Failed to identify user:", error);
        }
    }
    async getStudyMetrics(organizationId, studyId) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/organizations/${organizationId}/studies/${studyId}/metrics`, authenticatedApiConfig(this.authManager));
        return response.data;
    }
    async getIASMetrics(dateRange) {
        var _a, _b;
        const params = dateRange
            ? {
                startDate: (_a = dateRange.startDate) === null || _a === void 0 ? void 0 : _a.toISOString(),
                endDate: (_b = dateRange.endDate) === null || _b === void 0 ? void 0 : _b.toISOString(),
            }
            : {};
        const response = await axios.get(`${this.environment.API_BASE_URL}/ias/metrics`, {
            ...authenticatedApiConfig(this.authManager),
            params,
        });
        return response.data;
    }
}
